import * as React from 'react';
import {
  LogoutOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Avatar, Button, Dropdown, Menu, MenuProps, Space } from 'antd';
import {
  UserContextProps,
  AgentContextProps,
  AgentContext,
  UserContext,
  OrgContext,
  OrgContextProps
} from '@interface/index';
import { Link } from 'react-router-dom';
import { MenuInfo } from 'rc-menu/lib/interface';
import { localizedString } from '@locale/index';
import { getMasterAgentName, getOrgId, getOrgName, isCopilotPage, isKnowledgeAgent, isOrgMember, isOrgOwner, isProviderAgent, orgNameToPathComponent, removeTokenCookie } from '@lib/index';
import { layoutBackgroundColor, whiteColor } from '@config/styledVar';

const logo = require('@static/image/logo.png');
const logoIcon = require('@static/image/logo-icon.png');
const copilotIcon = require('@static/image/copilot/copilot-xiao.png');

const SidebarKeys = {
  OrgList: '/org',
  ThirdParty: '/third_party'
};

const SidebarKeyRegxMap = {
  [SidebarKeys.OrgList]: [/\/org/, /\/org\/add/],
  [SidebarKeys.ThirdParty]: [/\/third_party/]
};

export interface ISidebarProps {
  openKeys: string[];
  collapsed: boolean;
  history: any;
  $user: UserContextProps;
  $org: OrgContextProps;
  $agent: AgentContextProps;
  onCopilotClick: (e: any) => void;
  showCopilot: boolean;
}

export interface ISidebarState {
  selectedKeys: string[];
}

class TopbarComp extends React.Component<ISidebarProps, ISidebarState> {
  state: ISidebarState = {
    selectedKeys: []
  };
  unListen: any;

  componentDidMount() {
    const listenSelectedKeys = () => {
      if (location.pathname) {
        this.selectKey(location.pathname);
      }
    };

    listenSelectedKeys();

    this.unListen = this.props.history.listen(() => {
      listenSelectedKeys();
    });
  }

  componentWillUnmount() {
    if (this.unListen) {
      this.unListen();
      this.unListen = null;
    }
  }

  render() {
    const { collapsed, $agent, $user, $org, history, onCopilotClick, showCopilot } = this.props;
    const org = $org && $org.org;
    const agent = $agent && $agent.agent;
    const { selectedKeys } = this.state;
    const path = window.location.pathname;
    // return !(path.endsWith('library') || path.endsWith('version'));

    const trItems = [
      {
        style: { height: 50 },
        key: 'user',
        label: <Space
          key="user-span"
          style={{ width: 140 }}
          direction="vertical"
          size={4}
        >
          {/* <UserOutlined key="icon" /> */}
          {localizedString('sign_in_as')}
          <div style={{ fontWeight: 'bold' }}>
            {$user.user.nickname}
          </div>
        </Space>
      },
      {
        type: 'divider'
      },
      {
        key: 'org-list',
        label: localizedString('your_orgs')
      },
      {
        type: 'divider'
      },
      {
        key: 'profile',
        label: 'Your profile'
      },
      {
        type: 'divider'
      }

    ];

    if (getOrgId() && isOrgOwner()) {
      trItems.push({
        key: 'billing',
        label: localizedString('org_setting_billing', undefined, 'Billing')
      },
        {
          type: 'divider'
        });
    }

    trItems.push({
      key: 'logout',
      label: <span key="logout-span">
        {localizedString('common_exit')}
      </span>
    });

    return (
      <div className="admin-top" style={{ background: isCopilotPage() ? whiteColor : layoutBackgroundColor }}>
        <Space key="nav-space">
          <div className="sidebar-logo" style={{ background: isCopilotPage() ? whiteColor : layoutBackgroundColor }} key="logo">
            <Link to="/">
              {collapsed ? (
                <img className="logo-icon-img" src={logoIcon} />
              ) : (
                <img className="logo-img" src={logo} />
              )}
            </Link>
          </div>
          {org &&
            <>
              <Link to={`/org/${orgNameToPathComponent(org.name)}/agent`}>
                {org.name}
              </Link>
              {/* </Dropdown> */}
              {agent &&
                <>
                  <span style={{ margin: '0 8px' }}>/</span>
                  <Link to={`/org/${orgNameToPathComponent(org.name)}/agent/${getMasterAgentName()}/${agent.language}/${isKnowledgeAgent() ? 'knowledge' : 'type'}`}>
                    {agent.name}
                    {/* <DownOutlined /> */}
                  </Link>
                  {/* </Dropdown> */}
                  {/* {agent &&
                    <label className="nav-label" style={{ marginLeft: 24 }}>{localizedString(`agent_privacy_${agent.privacy}`)}</label>
                  } */}

                </>
              }
            </>
          }
          {!path.endsWith('copilot') &&
            <Menu
              className="top-bar"
              theme={'light'}
              style={{ width: '100%', minWidth: 500 }}
              selectedKeys={selectedKeys}
              mode="horizontal"
              items={$user.user && [{
                key: SidebarKeys.ThirdParty,
                className: 'bold',
                label: <Link to="/third_party">
                  <span>{localizedString('topbar_3rd')}</span>
                </Link>

              }] || []}
            /> || ''
          }
        </Space>
        {$user.user &&
          <Space direction="horizontal" align="center">
            {/* <div style={{ background: 'inherit', width: 40, height: 40 }}
              onDoubleClick={(e: any) => {
                onCopilotClick(e);
              }}
            >
            </div> */}
            {/* {isOrgMember() &&
              $org.org && $org.org.copilotEnabled &&
              !showCopilot &&
              <div style={{ background: 'inherit' }}
                onClick={(e: any) => {
                  onCopilotClick(e);
                }}
              >
                <img
                  style={{ background: 'inherit', height: 24 }}
                  className="logo-icon-img" src={copilotIcon} />
              </div>
            } */}
            <Dropdown
              key="user-menu"
              trigger={['click']}
              menu={{
                items: trItems as any,
                onClick: (info: MenuInfo) => {

                  switch (info.key) {
                    case 'logout': {
                      removeTokenCookie();

                      this.props.$agent.handleAgent();
                      this.props.$user.handleUser({});
                      this.props.history.push(window.location.pathname.endsWith('copilot') ? 'copilot_login' : '/login');
                      break;
                    }
                    case 'profile':
                      this.props.$org.handleOrg();
                      history.push('/account');
                      break;
                    case 'org-list':
                      history.push('/org');
                      break;
                    case 'billing':
                      history.push(`/org/${getOrgName()}/billing`);
                      break;
                    default:
                      break;
                  }
                }
              }}
            >
              <div
                // style={{ height: 44 }}
                className="button-area"
                key="button-area">
                <Avatar
                  size={24}
                  src={$user.user.headimgurl}
                  icon={<UserOutlined />} // 如果图片加载失败，会显示 UserOutlined 图标
                  style={{
                    cursor: 'pointer',
                  }}
                />
              </div>
            </Dropdown>
          </Space>
          // <NiPopMenu
          //   key="user-menu"
          //   options={[{
          //     label: <div key="user-span" style={{ padding: 8 }}>
          //       {/* <UserOutlined key="icon" /> */}
          //       Signed in as
          //       <div style={{ fontWeight: 'bold' }}>
          //         {$user.user.nickname}
          //       </div>
          //     </div>,
          //     value: 'user'
          //   }, {
          //     label: <span key="logout-span">
          //       <LogoutOutlined key="icon" />
          //       {localizedString('common_exit')}
          //     </span>,
          //     value: 'logout'
          //   }]}
          //   onOptionClick={(value: string) => {
          //     if (value === 'logout') {
          //       removeTokenCookie();

          //       this.props.$agent.handleAgent();
          //       this.props.$user.handleUser({});
          //       this.props.history.push('/login');
          //     } else if (value === 'user') {
          //       this.props.$org.handleOrg();
          //       history.push('/account');
          //     }
          //   }}
          // >
          //   <div
          //     style={{ height: 44 }}
          //     className="button-area"
          //     key="button-area">
          //     <img key="user-avatar"
          //       src={$user.user.headimgurl}
          //       style={{
          //         width: 24,
          //         height: 24,
          //         cursor: 'pointer',
          //         borderRadius: 12
          //       }}
          //     />
          //   </div>
          // </NiPopMenu>

        }

      </div>
    );
  }

  selectKey = (path: string) => {

    if (path && path.startsWith('/org')) {
      this.setState({
        selectedKeys: ['/org']
      });
    } else if (path && path.startsWith('/third_party')) {
      this.setState({
        selectedKeys: ['/third_party']
      });
    } else {
      this.setState({
        selectedKeys: []
      });
    }
  }

  matchPath = (path: string, regex: RegExp) => {
    const ret = path.match(regex);
    return ret && ret.length && ret[0] === path;
  }
}

export const Topbar = (props: any) => (
  <AgentContext.Consumer>
    {($agent: AgentContextProps) => (
      <OrgContext.Consumer>
        {($org: OrgContextProps) =>
          <UserContext.Consumer>
            {($user: UserContextProps) => (
              <TopbarComp {...props} $user={$user} $org={$org} $agent={$agent} />
            )}
          </UserContext.Consumer>}
      </OrgContext.Consumer>
    )}
  </AgentContext.Consumer>
);
